module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/eye_close-f045a012d80e8eba0c8e2520865aaf6d.svg&quot;;"